import * as React from 'react';
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { MIAPACons } from '../../Utils/MipaConstant';

import './planner.scss';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import Moment from 'react-moment';

import { PersonaInitialsColor } from 'office-ui-fabric-react/lib/Persona';
import { Facepile, IFacepileProps, OverflowButtonType } from 'office-ui-fabric-react/lib/Facepile';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
import { DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import { GraphRequest } from '../../Utils/GraphRequest';
import { Helper } from '../../Utils/Helper';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { User } from '../../Entity/User';
import TaskCommentService from '../../service/TaskCommentService';
export interface IProps {
  data?: CPlannerTask;
  Users: any[];
  Header: any;
  Phrases: { commentscount: string; };
  Progress: any;
  ThreadId: string;
  ReloadPlannerTasks: (arg0: number) => void;
  CurrentUser: User
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  CalloutVisible?: boolean;
  firstDayOfWeek?: DayOfWeek;

  Comments: any;
  ThreadId?:string
}




export default class TaskComments extends React.Component<IProps, IContextualMenuState>{

  private _menuButtonElement: HTMLElement | null;
  public commenttext = "";
  constructor(props: IProps) {
    super(props);
    this.state = {
      CalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      Comments: null,
      ThreadId:props.ThreadId
    };
  }
  //UserEmail.split("@")[1]
  public render() {
    const { CalloutVisible, beakWidth, Comments,ThreadId } = this.state;
    let rowcss = "ms-Grid-row miparow " + 'detailrow mt-20';
    let threads = [<div className={rowcss}>
      <div className="ms-Grid-col ms-sm12">
        <Spinner size={SpinnerSize.large} />
      </div>
    </div>];
    let heading = 'Comments ';
    if (ThreadId == null) {
      threads = [];
    }
    if (Comments && Comments.length > 0) {
      threads = [];
      heading = this.props.Phrases.commentscount.replace('{0}', Comments.length);
      for (var PostIndex = 0; PostIndex < Comments.length; PostIndex++) {
        var post = Comments[PostIndex];
        let user = this.props.Users.filter((u: { mail: any; }) => u.mail == post.from.emailAddress.address);
        var posterInitial = '';
        var posterNameslice = post.from.emailAddress.name.split(' ');
        for (var posterSliceIndex = 0; posterSliceIndex < posterNameslice.length; posterSliceIndex++) {
          if (posterNameslice[posterSliceIndex].length > 0) {
            posterInitial += posterNameslice[posterSliceIndex].substr(0, 1).toUpperCase();
          }
        }
        let persion = {
          //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
          imageUrl: Helper.GetDefaultImage(),
          imageInitials: posterInitial,
          personaName: post.from.emailAddress.name,
          initialsColor: PersonaInitialsColor.magenta
        };
        if (user && user.length > 0 && user[0].imagepath != null && user[0].imagepath != '') {
          persion.imageUrl = user[0].imagepath;
        }
        let facepileProps: IFacepileProps = {
          personas: [persion],
          maxDisplayablePersonas: 5,
          overflowButtonType: OverflowButtonType.none,
          overflowButtonProps: {
            ariaLabel: 'More users',
            onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
          },
          ariaDescription: 'To move through the items use left and right arrow keys.'
        };
        threads.push(
          <div className={rowcss}>
            <div className="ms-Grid-col ms-sm12">
              <div className='assignecontainer'>
                <Facepile {...facepileProps} />
                <div style={{ marginLeft: '46px' }}> <Moment format="DD MMM YY hh:mm A">{post.createdDateTime}</Moment></div>

                <div style={{ margin: '8px 0px' }}><span dangerouslySetInnerHTML={this.rawbody(post.body.content)} /></div>


              </div>
            </div>
          </div>
        );
      }
    }
    let styleobj = {};
    //let key='taskcomment_';
    if (ThreadId == null) {
      //key +=Math.round(+new Date() / 1000);
      styleobj = { cursor: 'pointer' };
    } else {
      styleobj = { cursor: 'pointer', color: 'green' };
      //key +=ThreadId;
    } 
    return (
      <div>
        <i className="ms-Icon ms-Icon--SkypeMessage" style={styleobj} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked} ></i>
        {CalloutVisible ? (
          <Callout

            className="ms-Callout-callout"
            onDismiss={this._onCalloutDismiss}
            target={this._menuButtonElement}
            directionalHint={DirectionalHint.topAutoEdge}
            coverTarget={false}
            isBeakVisible={true}
            gapSpace={0}
            beakWidth={beakWidth}
          >
            <div className='detailcallout'>
              <div className='plannerdetailheader'>
                {heading}
              </div>
              <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                <div className="ms-Callout-content ms-Grid">
                  <div className="commentboxcontainer mb-10">
                    <TextField
                      className=""
                      onChange={(e) => {
                        this.commenttext = e.target['value'];
                        let prevstate = { ...this.state };
                        prevstate.CalloutVisible=true;
                        this.setState(prevstate);
                        /*this.setState({ CalloutVisible: true });*/
                      }}
                      value={this.commenttext}
                      label="Comment"
                      multiline={true}
                      autoAdjustHeight={true}
                    />
                    <button type='button' className='ms-Button ms-Button--default viewswitchbtn plannertask mt-10'
                      onClick={this.savecomment}
                    >Post</button>
                  </div>
                  <div>
                    {threads}
                  </div>
                </div>
              </div>
            </div>
          </Callout>
        ) : null}
      </div>
    );
  }
  private rawbody = (text: any) => {
    return { __html: text };
  }
  private _onCalloutDismiss = (): void => {
    let prevstate = { ...this.state };
    prevstate.CalloutVisible=false;
    this.setState(prevstate);
    
  }

  private _onMenuClicked = (): void => {
    if (this.state.Comments == null && this.state.ThreadId != null) {
      let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupPosts.replace('{0}', this.props.data.groupId).replace('{1}', this.props.data.conversationThreadId) + Math.round(+new Date() / 1000);
      //let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupPosts.replace('{0}', this.props.data.groupId).replace('{1}', this.props.data.conversationThreadId);
      let header=this.props.Header;
      GraphRequest.GET(detailapi, header, (detail: { data: { value: any; }; }) => {
        let data = detail.data.value;
       // console.log(data);
        /*data.sort( (a, b)=> {
            var dateA =  new Date(a["createdDateTime"]);
            var dateB = new Date(b["createdDateTime"]);
            return dateA > dateB ? 1 : -1;                
        });*/
        Helper.SortList(data, 'createdDateTime', false, true);
        let prevstate = { ...this.state };
        prevstate.Comments=data;
        this.setState(prevstate);
        
      }, (error: any) => {
        console.error(error);
        //this.props.ReloadPlannerTasks(this.props.data.col);

      }, this.props.Progress);
    }
    
    let prevstate = { ...this.state };
    prevstate.CalloutVisible= !this.state.CalloutVisible;
    this.setState(prevstate);
    
   /*this.setState({CalloutVisible:!this.state.CalloutVisible})*/
  }
  private savecomment = () => {

    const commentParams = {
      commenttext: this.commenttext,
      props: {...this.props},
      detailSuccesscallback: (conid: any)=> {
        let newcomment={
          body:{
          content:this.commenttext
          },
          from:{
          emailAddress:{
          name:this.props.CurrentUser.displayName,
          address:this.props.CurrentUser.mail
          },
          createdDateTime:new Date()
          }
          };
          let commentlist=this.state.Comments;
          if(commentlist==null){
            commentlist=[newcomment];
          }else{
            commentlist.unshift(newcomment);
          }
        this.commenttext='';
        let prevstate = { ...this.state };
        prevstate.Comments= commentlist;
        prevstate.CalloutVisible=false;
        prevstate.ThreadId=conid;
        this.setState(prevstate);
        //this.setState({ Comments:commentlist,CalloutVisible: false,ThreadId:conid });
        //this.props.ReloadPlannerTasks(this.props.data.col);
      },
      detailErrorcallback:  (detailError)=> { },
      errorcallback:  (error)=> { },
      successcallback:  (conid)=> {
        let newcomment={
          body:{
          content:this.commenttext
          },
          from:{
          emailAddress:{
          name:this.props.CurrentUser.displayName,
          address:this.props.CurrentUser.mail
          },
          createdDateTime:new Date()
          }
          };
          let commentlist=this.state.Comments;
          if(commentlist==null){
            commentlist=[newcomment];
          }else{
            commentlist.unshift(newcomment);
          }
        this.commenttext='';
        let prevstate = { ...this.state };
        prevstate.Comments= commentlist;
        prevstate.CalloutVisible=false;
        prevstate.ThreadId=conid;
        this.setState(prevstate);
        //this.setState({ Comments:commentlist,CalloutVisible: false,ThreadId:conid });
       
        //this.props.ReloadPlannerTasks(this.props.data.col);
      }
    };
    commentParams.props.ThreadId=this.state.ThreadId;
    TaskCommentService.savecomment(commentParams);
    /*if (this.commenttext.length > 0) {
      let email = { emailAddress: { name: this.props.CurrentUser.displayName, address: this.props.CurrentUser.mail } };
      if (this.props.ThreadId == null) {

        let postJSON = {
          "topic": this.props.data.title,
          "threads": [{
            "posts": [{
              "body": {
                "contentType": "html",
                "content": this.commenttext
              },
              "newParticipants": [email]
            }]
          }]
        };

        let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupConversation.replace('{0}', this.props.data.groupId)
        GraphRequest.POST(detailapi, this.props.Header, postJSON, (detail: { data: { id: any; }; }) => {
          let conobj = { "conversationThreadId": detail.data.id };
          detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlannerTask.replace('{0}', this.props.data.id);
          GraphRequest.Patch(detailapi, this.props.Header, conobj, (successres: any) => {
            this.setState({
              Comments: []
            });
            this.props.ReloadPlannerTasks(this.props.data.col);
          }, (failres: any) => { }, this.props.Progress, this.props.data['@odata.etag']);

        }, (error: any) => {

        }, this.props.Progress);

      } else {
        var obj = {
          post: {
            body: { content: this.commenttext, contentType: "html" },
            from: email,
            lastModifiedDateTime: moment().format()
          }
        }
      }
      this.props.ReloadPlannerTasks(this.props.data.col);
      let taskcomment = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupReply.replace('{0}', this.props.data.groupId).replace('{1}', this.props.ThreadId);
      GraphRequest.POST(taskcomment, this.props.Header, obj, (sucres: any) => {
        this.setState({
          Comments: []
        });
        this.props.ReloadPlannerTasks(this.props.data.col);
      }, (errres: any) => { }, this.props.Progress);
    } */
  }

}
